import { stringify } from 'qs';
import { SERVER_URL } from 'constants/index';

export const searchProducts = (searchQuery, updateCatalogState) => {
    let queryCatalog = {
        searchCriteria: {
            current_page: 1,
            filter_groups: [
                {
                    filters: [
                        {
                            field: 'name',
                            value: `%${searchQuery}%`,
                            condition_type: 'like'
                        }
                    ]
                }
            ]
        }
    };

    if (searchQuery && searchQuery.length > 2) {
        queryCatalog = stringify(queryCatalog);
        fetch(SERVER_URL + 'products?' + queryCatalog)
            .then(response => response.json())
            .then(json => {
                updateCatalogState({
                    catalogProducts: json.items,
                    isLoading: false,
                    catalogSize: json.total_count,
                    pageSize: json.total_count
                });
            })
            .catch(error => console.error(error));
    }
};

export default searchProducts;



// WEBPACK FOOTER //
// ./src/modules/Catalog/actions/searchProducts.js